import { jsx as _jsx } from "react/jsx-runtime";
import 'react';
import TreeLeaf from './TreeLeaf';
import { excludeFromList } from './excludeFromList';
const TreeLeafList = (props) => {
    const { leafList, hasMultiselect, showRadioButtons, selectedItems, selectedGroups, onSelectionChange } = props;
    const handleItemSelection = (itemId) => {
        const isSelected = selectedItems.includes(itemId);
        const newSelectedItems = isSelected
            ? excludeFromList(selectedItems, itemId)
            : [...selectedItems, itemId];
        onSelectionChange(newSelectedItems, selectedGroups);
    };
    const handleSetItemActive = (itemId) => onSelectionChange([itemId], []);
    return leafList.map(item => (_jsx(TreeLeaf, { item: item, hasMultiselect: hasMultiselect, showRadioButtons: showRadioButtons, isSelected: selectedItems.includes(item.id), onSelectItem: () => handleItemSelection(item.id), onActiveItem: () => handleSetItemActive(item.id) }, item.id)));
};
TreeLeafList.displayName = 'TreeLeafList';
export default TreeLeafList;
